import React from 'react';

import svg from './assets/icons-24-visibility-on.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

/** @deprecated Use the Icon component from the design-system-core-components package. */
export const IconVisibilityOn = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-visibility-on" />
);
